<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Program</h2>
        </span>
      </span>
      <div class="col-lg-12 adduser-container-hgt p-3">
        <form [formGroup]="programForm">
          <jni-program-header
            [parent]="programForm"
            (emitFormGroup)="setFormData($event)"
            [platformList]="platfromList"
            [facilitatorList]="facilitatorList"
            [threePLList]="threePlList"
            [bcList]="bcList"
            [pgmDimensionList]="programDimensions"
            [validateLogin]="validateLoginData"
            [isAdminCheck]="isAdminOrFinance"
            [isEditDimension]="isEditDimension"
            [mode]="mode">
          </jni-program-header>
          <div class="d-flex py-3 has-sticky justify-content-end gap-2">
            <p-button
              label="Cancel"
              (click)="navigateToProgramListing()"
              variant="outlined"
              severity="secondary" />

            <p-button
              label="Save"
              (click)="onSubmit()"
              [disabled]="!programForm.valid" />
          </div>
        </form>
      </div>
    </p-card>
  </div>
</div>
